import React, { Component } from 'react';
// Default setup
import Navigation from './layout/navigation/Navigation';
import Footer from './layout/footer/Footer';
import WarpLarge from './layout/warp/WarpLarge';
import TitleFront from './layout/portfolio/TitleFront';
import Quotes from './layout/Quotes';

const faq_1 = {
  question: "I am looking for a product designer. Would you work for freelancing?",
  answer: "To be honest, I am very cautious about my design quality and prefer to focus on my full-time work. Chasing two rabbits at once isn't my thing! 😅"
}

const faq_2 = {
  question: "I am organising a conference. Would you like to give a talk?",
  answer: "I'd love to! Please let me know the detail, compensation, and the length of presentation I need to prepare. "
}

const faq_3 = {
  question: "I am a designer and your work is interesting. Can we have a chat?",
  answer: "Of course you can. I've been enjoying talking with other designers for user-research, university assignments, or just chatting for fun."
}

class AboutMe extends Component {
  render () {
    return(
      <div>
        <Navigation />
        <TitleFront title={"Contact me"} themeColor={'#292C34'}/>
        <Quotes question={faq_1.question} answer={faq_1.answer}/>
        <Quotes question={faq_2.question} answer={faq_2.answer}/>
        <Quotes question={faq_3.question} answer={faq_3.answer}/>
        <WarpLarge />
        <Footer />
      </div>
    );
  }
}

export default AboutMe;



// WEBPACK FOOTER //
// ./src/Contact.js